import { AxiosResponse } from "axios";
import { apisiseci } from "./api";
import { Cities } from "../@types/cities";
import { SlugCityParam } from "./api-tansquery/get-city-slug";

export const fetchCidadeBySlug = ({
  slug,
}: SlugCityParam): Promise<AxiosResponse<Cities>> =>
  apisiseci.get(`/cms/cidades/${slug}/`);
